var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-1 h-2 w-full rounded-full bg-ink-200"},[_c('div',{staticClass:"h-2 transform rounded-full transition-all duration-200 ease-in-out",class:{
      'bg-juniper': 50 >= _vm.completion,
      'bg-honey': 80 >= _vm.completion && _vm.completion > 50,
      'bg-cherry': _vm.completion > 80
    },style:({
      width: `${_vm.completion}%`
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }